const STEPS = [
  { key: 'upload', label: 'Upload' },
  { key: 'scope', label: 'Assemble' },
  { key: 'link', label: 'Link & Price' },
  { key: 'estimate', label: 'Estimate' },
  { key: 'output', label: 'Output' }
]

const WorkflowStepper = ({ workflowStep, scopeProgress, onStepClick }) => {
  const activeIndex = STEPS.findIndex(s => s.key === workflowStep)
  const activeStep = activeIndex >= 0 ? activeIndex : 0
  const canNavigate = typeof onStepClick === 'function'

  const hints = {
    upload: 'Upload bid schedule, plans, vendor quotes',
    scope: 'Build Assembly Items from source evidence',
    link: 'Link services + apply vendor pricing',
    estimate: 'Review in Estimating Cockpit',
    output: 'Generate bid output'
  }

  return (
    <div className="hmi-stepper" style={{ marginBottom: 20 }}>
      {STEPS.map((step, idx) => {
        let cls = 'step'
        if (idx < activeStep) cls += ' done'
        else if (idx === activeStep) cls += ' current'

        return (
          <button
            key={step.key}
            type="button"
            className={`${cls}${canNavigate ? ' clickable' : ''}`}
            onClick={() => canNavigate && onStepClick(step.key)}
            aria-current={idx === activeStep ? 'step' : undefined}
          >
            <div className="marker">
              <span className="step-dot">
                {idx < activeStep ? '\u2713' : idx + 1}
              </span>
              <span className="step-label">{step.label}</span>
            </div>
            <small className="step-sub">{hints[step.key]}</small>
          </button>
        )
      })}
    </div>
  )
}

export default WorkflowStepper
